/**
 * Тон и инициалы для плашки.
 *
 * Лежат в общем слое, а не при человеке, потому что человеком не
 * ограничиваются: тем же тоном красятся значок сервера и роль, а инициалы
 * берутся и с имени сервера. Обе функции знают только строку на входе.
 */

/**
 * Восемь тонов одной светлоты. Список короткий намеренно: чем больше
 * оттенков, тем пестрее список — а нужна различимость соседей, а не
 * уникальность каждого.
 *
 * В v2 тон светлый, а буквы поверх него тёмные (`--ui-tile-ink`) — прежде
 * было наоборот. Причина не во вкусе: плашка теперь лежит на стекле, и
 * тёмный тон на нём проваливается в фон, а светлый читается как предмет.
 * Тона разведены по кругу с шагом примерно в сорок градусов при одной
 * светлоте — соседи в списке различаются, а список не пестрит.
 */
export const TINTS = [
  "#a9a3d8",
  "#9db7c8",
  "#93b8bd",
  "#96b3a4",
  "#adb492",
  "#b0a894",
  "#c8a49b",
  "#c8a9b8",
];

/** Цвет плашки выводится из хэндла: у одного человека он всюду один. */
export function tint(seed: string): string {
  let hash = 0;
  for (const char of seed) hash = (hash * 31 + char.charCodeAt(0)) % 997;
  return TINTS[hash % TINTS.length];
}

/**
 * Две буквы для плашки без аватара.
 *
 * Берутся из отображаемого имени, а не из хэндла: человека узнают по имени.
 * Составное имя даёт по букве от каждого слова, односложное — две первые.
 */
export function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "??";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

/** Тон, приглушённый к чёрному, — второй ряд палитры ролей, уже готовым `#rrggbb`. */
export function deepTint(hex: string): string {
  const channel = (at: number) => Math.round(parseInt(hex.slice(at, at + 2), 16) * 0.55);
  return `#${[1, 3, 5].map((at) => channel(at).toString(16).padStart(2, "0")).join("")}`;
}

/**
 * Баннер без картинки и без выбранного цвета — градиент тоном по хэндлу,
 * как у плашки без аватара. Один на редактор профиля и карточку: что видно
 * при правке, то и показывается другим.
 */
export function bannerTint(handle: string): string {
  return `linear-gradient(160deg, ${tint(handle)}, color-mix(in srgb, ${tint(handle)} 55%, #000))`;
}
